/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Rohan",
  logo_name: "Rohan",
  nickname: "MartyMiniac",
  full_name: "Rohan Verma",
  subTitle:
    "Full Stack, Desktop App and Enterprise Developer. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1nynp9LS6opXuThVIVW2VIQoRFxOlGmY5/view?usp=sharing",
  mail: "mailto:rohanvermaara@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/MartyMiniac",
  linkedin: "https://www.linkedin.com/in/martyminiac/",
  gmail: "rohanvermaara@gmail.com",
  // gitlab: " ",
  // facebook: " ",
  // twitter: " ",
  // instagram: " ",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using native Android",
        "⚡ Backend development using NodeJS, ExpressJS and Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "simple-icons:csharp",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Android App Development",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
    {
      title: "Software Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experienced developing Desktop App using win32 api GDI",
        "⚡ Experienced developing enterprise applications using .NET",
        "⚡ Experience with 50+ Projects (including client projects)",
      ],
      softwareSkills: [
        {
          skillName: "C",
          fontAwesomeClassname: "arcticons:clanguage",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "vscode-icons:file-type-cpp3",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: ".NET",
          fontAwesomeClassname: "cib:dot-net",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Rust",
          fontAwesomeClassname: "skill-icons:rust",
          style: {
            backgroundColor: "transparent",
            color: "#6E6E6E",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Certified Azure Developer",
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing web apps on Azure",
      ],
      softwareSkills: [
        {
          skillName: "Azure",
          fontAwesomeClassname: "devicon:azure",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "devicon:kubernetes",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Siksha 'O' Anusandhan University",
      subtitle: "Computer Science and Engineering",
      logo_path: "Siksha_‘O’_Anusandhan.png",
      alt_name: "DAL",
      duration: "2019 - 2023",
      descriptions: [
        "⚡ studied core subjects like Data Structures, DBMS, Networking, Security, etc",
        "⚡ Learn Advanced Topics in Cloud Computing, Cloud Architecture along with Serverless Computing",
        "⚡ Worked on projects on courses like Mobile Computing and Web Technologies.",
        "⚡ have implemented several projects based on what I've learnt under my Computer Engineering course.",
      ],
      website_link: "https://www.soa.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "AZ 900",
      subtitle: "Azure",
      logo_path: "azure.png",
      certificate_link: " ",
      alt_name: "Azure",
      color_code: "#ffc475",
    },
    {
      title: "AI 900",
      subtitle: "Azure",
      logo_path: "azure.png",
      certificate_link: " ",
      alt_name: "Azure",
      color_code: "#ffc475",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed two internships. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Consultant",
          company: "Microsoft",
          company_url: "https://microsoft.com",
          logo_path: "Microsoft_logo.svg.png",
          duration: "Aug 2023 - Ongoing",
          location: "Hyderabad, India",
          description:
            "Developed network traffic analysis code, designed a landing zone for G42, and created Python tools for secure repo migrations.",
          color: "#2962FF",
        },
        {
          title: "SDE Intern",
          company: "Siemens",
          company_url: "https://siemens.com/",
          logo_path: "siemens.png",
          duration: "May 2021 - October 2021",
          location: "Noida, India",
          description:
            "Developed backend systems for IoT devices at Siemens, creating an MVP handling 100K requests per minute, displaying power consumption, generating bills, and providing analytics. Enhanced skills in scalable backend solutions.",
          color: "#2962FF",
        },
        {
          title: "Lead Developer",
          company: "Congle (Startup)",
          company_url: "https://congle.in/",
          logo_path: "congle.png",
          duration: "March 2021 - December 2021",
          location: "Bhubaneshwar, India",
          description:
            "As the sole backend developer, built the infrastructure and code from scratch for a real-time chat, social media feed recommendation, notification service, and voice chat service. Successfully launched the application, achieving 1K MAU.",
          color: "#2962FF",
        },
        {
          title: "Research Intern",
          company: "Samsung",
          company_url: "https://samsung.com/",
          logo_path: "samsung.png",
          duration: "June 2021 - December 2021",
          location: "Bhubaneshwar, India",
          description:
            "Developed neural models for optimizing dark images, optimized and developed code for custom hardware, and compiled it to run natively on ARM Cortex-A cores.",
          color: "#2962FF",
        },
        {
          title: "Freelance Software Developer",
          company: " ",
          company_url: " ",
          logo_path: "freelance.jpg",
          duration: "November 2019 - August 2023",
          location: "Bhubaneshwar, India",
          description:
            "Developed tailored software solutions using Django, Node.js, and React since 2019, built CLI tools with Java, C, and C++, and created personal projects like an in-memory database and a real-time music streaming platform, laying a strong foundation for my software developer roles.",
          color: "#2962FF",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Codex Mentorship",
          company: "Codex - Club",
          company_url: "https://codex-iter.in/",
          logo_path: "codexiter.png",
          duration: "2019-2023",
          location: " ",
          description:
            "Helped juniors with their coding problems and helped them understand the concepts better.",
          color: "#4285F4",
        },
        {
          title: "Codex Coordinator",
          company: "Codex - Club",
          company_url: "https://codex-iter.in/",
          logo_path: "codexiter.png",
          duration: "2019-2023",
          location: " ",
          description:
            "Lead and organized several coding workshops and events for the club.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Backend Projects and Desktop Tools. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "rohan.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can.",
  },
  blogSection: {
    title: "Github",
    subtitle:
      "Here is my personal Github Page. You will find some of my projects here.",
    link: "https://github.com/MartyMiniac",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "soundGen",
      url: "https://github.com/MartyMiniac/soundGen",
      description: "Generates sound.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      name: "JavaGaussianBlur",
      url: "https://github.com/MartyMiniac/JavaGaussianBlur",
      description: "A CLI tool to apply Gaussian Blur to an image.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
    },
    {
      name: "SecDhar",
      url: "https://github.com/MartyMiniac/SecDhar",
      description: "Get recipes for hundreds and thousands of dishes",
      languages: [
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "listentube",
      url: "https://github.com/MartyMiniac/listentube",
      description: "Play audio of any Youtube video.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Flask",
          iconifyClass: "logos-flask",
        },
      ],
    },
    {
      name: "Proxyfy",
      url: "https://github.com/MartyMiniac/Proxyfy",
      description:
        "A MITM Proxy tool to intercept and modify HTTP/HTTPS requests.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      name: "HillDweller",
      url: " ",
      description:
        "An online cloud computing platform for developers to run serverless javascript based function app on cloud.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-java",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      name: "filepipe",
      url: " ",
      description: "A peer-to-peer IPV6 based file sharing tool.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      name: "CDatabase",
      url: "htthttps://github.com/MartyMiniac/CDatabase",
      description:
        "An in-memory database written in C using TCP socket programing.",
      languages: [
        {
          name: "C",
          iconifyClass: "logos-c",
        },
      ],
    },
    {
      name: "tabbies",
      url: "https://github.com/MartyMiniac/tabbies",
      description:
        "A social media platform for connecting over shared hobbies, posting content, and using a recommendation engine for post propagation.",
      languages: [
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "algoVisualizer",
      url: "https://github.com/MartyMiniac/algoVisualizer",
      description: "An application to visualize sorting algorithms.",
      languages: [
        {
          name: "HTML",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS",
          iconifyClass: "logos-css-3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Codex Manage Bot",
      url: "https://github.com/MartyMiniac/codex-manage-bot",
      description: "A Telegram bot to manage the Codex Club's telegram Server.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "SOA ITER Notice Scraper",
      url: "https://github.com/MartyMiniac/soaIterNoticeScraper",
      description:
        "A web scraper to get the latest notices from the SOA ITER website.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      name: "Multi-Threaded-Chat-Messenger",
      url: "https://github.com/MartyMiniac/Multi-Threaded-Chat-Messenger",
      description:
        "A peer to peer chat messenger using multi-threading in Java with NAT propogation.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
    },
    {
      name: "sunosuno",
      url: "https://github.com/MartyMiniac/sunosuno",
      description:
        "A web socket based web app that allows to stream music using JioSaavn APIs",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Flask",
          iconifyClass: "logos-flask",
        },
      ],
    },
    {
      name: "Complirun",
      url: " ",
      description:
        "A compilation engine to compare the output of programs to the expected output.",
      languages: [
        {
          name: "C++",
          iconifyClass: "logos-cplusplus",
        },
      ],
    },
    {
      name: "Random Graphic Pattern",
      url: "https://github.com/MartyMiniac/RandomGraphicPattern",
      description:
        "A Java Program that creates random patterns of pixels suitable to be used as a background.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
    },
    {
      name: "Word List",
      url: "https://github.com/MartyMiniac/Word-List",
      description: "Create a personal dictionary of words and their meanings.",
      languages: [
        {
          name: ".NET",
          iconifyClass: "logos-dotnet",
        },
      ],
    },
    {
      name: "StopWatch",
      url: "https://github.com/MartyMiniac/StopWatch",
      description: "A simple stopwatch application.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
    },
    {
      name: "Online Class Website",
      url: " ",
      description:
        "A website to take online classes, attendance and manage students.",
      languages: [
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "HTML",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS",
          iconifyClass: "logos-css-3",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
